/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function CgTextures(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5002 10.083L10.0832 17.5H7.75015L17.5002 7.74999V10.083ZM17.5002 17.5H14.1671L17.5002 14.167V17.5ZM17.4582 3.72948L3.72964 17.4375H2.56265V16.2705L16.2707 2.56249H17.4582V3.72948ZM2.50015 12.25V9.91698L9.91714 2.49999H12.2502L2.50015 12.25ZM2.50015 5.833V2.49999H5.83316L2.50015 5.833Z"
        fill="#35424F"
      />
    </svg>
  )
}

CgTextures.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default CgTextures
